var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/administration/lookups/lookups-detail.jade
// module id = 179
// module chunks = 0